<template>
  <div v-if="!selecionouSegmento">
    <div
      class="icms-st-perguntas-container"
      v-for="(pergunta, index) in imposto.perguntas"
      :key="index"
    >
      <RadioButton
        :imposto="pergunta"
        :classe="imposto.classe"
        :seleciona="seleciona"
        :loading="loading"
      />
      <Registro>
        <Descricao :titulo="'Segmento'" :descricao="pergunta.segmento" />
        <div v-if="pergunta.segmento" class="separador" />

        <Cabecalho v-if="pergunta.cest" :tipo="'ncm'" :titulo="'CEST'" :aliquota="pergunta.cest" />
        <div v-if="pergunta.cest" class="separador" />

        <Cabecalho
          v-if="pergunta.valor_label && pergunta.id_imposto != 100"
          :tipo="'icone'"
          :classe="imposto.classe"
          :titulo="pergunta.label"
          :aliquota="pergunta.valor_label"
        />
        <div class="separador" v-if="pergunta.valor_label && pergunta.id_imposto != 100" />

        <Cabecalho
          v-if="pergunta.label_interestadual"
          :classe="imposto.classe"
          :titulo="'Atribuição de Responsabilidade'"
          :aliquota="pergunta.label_interestadual.toUpperCase()"
        />
        <Cabecalho
          protocolo
          v-if="pergunta.label_interestadual"
          :tipo="'html'"
          :titulo="pergunta.valor_label_interestadual"
        />

        <div class="separador" v-if="pergunta.label_interestadual" />

        <Inaplicabilidade v-if="pergunta.id_imposto == 100" :texto="pergunta.valor_label" />

        <QuadroZebra v-if="pergunta.id_imposto != 100" :dados="pergunta" />
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="icms-st-perguntas-container">
      <EditButton :classe="imposto.classe" :edita="edita" :loading="loading" />
      <Registro>
        <Descricao :titulo="'Segmento'" :descricao="segmentoSelecionado.segmento" />
        <div v-if="segmentoSelecionado.segmento" class="separador" />

        <Cabecalho
          v-if="segmentoSelecionado.cest"
          :tipo="'ncm'"
          :titulo="'CEST'"
          :aliquota="segmentoSelecionado.cest"
        />
        <div v-if="segmentoSelecionado.cest" class="separador" />

        <Cabecalho
          v-if="segmentoSelecionado.valor_label && segmentoSelecionado.id_imposto != 100"
          :tipo="'icone'"
          :classe="imposto.classe"
          :titulo="segmentoSelecionado.label"
          :aliquota="segmentoSelecionado.valor_label"
        />
        <div
          class="separador"
          v-if="segmentoSelecionado.valor_label && segmentoSelecionado.id_imposto != 100"
        />

        <Cabecalho
          v-if="segmentoSelecionado.label_interestadual"
          :classe="imposto.classe"
          :titulo="'Atribuição de Responsabilidade'"
          :aliquota="segmentoSelecionado.label_interestadual.toUpperCase()"
        />
        <Cabecalho
          protocolo
          v-if="segmentoSelecionado.label_interestadual"
          :tipo="'html'"
          :titulo="segmentoSelecionado.valor_label_interestadual"
        />
        <div class="separador" v-if="segmentoSelecionado.label_interestadual" />

        <Inaplicabilidade
          v-if="segmentoSelecionado.id_imposto == 100"
          :texto="segmentoSelecionado.valor_label"
        />

        <QuadroZebra v-if="segmentoSelecionado.id_imposto != 100" :dados="segmentoSelecionado" />
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import QuadroZebra from "@/components/QuadroZebra/QuadroZebra.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
export default {
  name: "PerguntasIcmsSt",

  props: {
    imposto: Array | Object,
    loading: Boolean,
    segmentoSelecionado: Object,
    seleciona: Function,
    selecionouSegmento: Boolean,
    edita: Function
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Inaplicabilidade,
    QuadroZebra,
    RadioButton,
    Registro
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.icms-st-perguntas-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
